import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { lcSkipToContent } from './lc-skip-to-content/lc-skip-to-content';
import { lcNavbar } from './lc-navbar/lc-navbar';

@Component({
  selector: 'lc-template, [lcTemplate]',
  imports: [lcSkipToContent, lcNavbar, RouterOutlet],
  templateUrl: './lc-template.html',
  host: { 'class': 'd-flex flex-column min-vh-100' }
})
export class lcTemplate {
  private readonly router = inject(Router);

  protected readonly subNavId = signal('');
  protected readonly subNavLabel = signal('');

  constructor() {
    this.updateSubNav(this.router.url);
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(),
      )
      .subscribe((event) => this.updateSubNav(event.urlAfterRedirects));
  }

  private updateSubNav(url: string): void {
    const hasSubNav = url.split('?')[0].split('#')[0] === '/home';
    this.subNavId.set(hasSubNav ? 'sub-nav' : '');
    this.subNavLabel.set(hasSubNav ? 'Skip to Sub-Navigation' : '');
  }
}
